import { api } from "@/lib/api";

export async function fetchAdminStats() {
  const { data } = await api.get("/admin/stats");
  return data;
}

export async function fetchAdminUsers() {
  const { data } = await api.get("/admin/users");
  return data.users;
}

export async function grantUserPlan(userId, plan, duration = "permanent") {
  const { data } = await api.patch(`/admin/users/${userId}/plan`, { plan, duration });
  return data.user;
}

export async function grantUserRole(userId, role) {
  const { data } = await api.patch(`/admin/users/${userId}/role`, { role });
  return data.user;
}

export async function deactivateUser(userId) {
  const { data } = await api.patch(`/admin/users/${userId}/deactivate`);
  return data;
}

export async function fetchAdminCodes() {
  const { data } = await api.get("/admin/codes");
  return data.codes;
}

export async function createAdminCode(payload) {
  const { data } = await api.post("/admin/codes", payload);
  return data.code;
}

export async function disableAdminCode(codeId) {
  const { data } = await api.patch(`/admin/codes/${codeId}/disable`);
  return data.code;
}
